<div class="px-6">
  <p-toast position="top-right" key="toastError"></p-toast>
  <p-toast position="top-right" key="toastSuccess"></p-toast>
  <p-card styleClass="my-3">
    <div class="flex align-items-center mb-3">
      <button
        pButton
        pRipple
        type="button"
        label="Voltar"
        icon="pi pi-arrow-left"
        class="p-button-outlined p-button-secondary"
        (click)="goBack()"
        [disabled]="buttonLoading"
        tooltipPosition="right">
      </button>
    </div>
    <p-fieldset legend="{{ isEdit ? 'Editar Nova Ocorrência' : 'Criar Nova Ocorrência'}}">
      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [scrollHeight]="'30rem'"
              [style]="stylePattern"
              [options]="contracts"
              inputId="filtroGrupos"
              [class]="!newOccurrence.contractId ? 'ng-invalid ng-dirty' : ''"
              [required]="true"
              [readonly]="true"
              [(ngModel)]="newOccurrence.contractId"
              optionLabel="description"
              optionValue="id"
              [disabled]="true"
              [filter]="true"
              placeholder="Selecionar"
              dropdownIcon="null"
              (onChange)="getMotives();getOperations();"
            >
              <ng-template let-contracts pTemplate="item">
                <div class="font-semibold text-center">
                  {{ contracts.description }}
                </div>
              </ng-template>
            </p-dropdown>
            <label htmlFor="filtroGrupos">Contratos</label>
          </span>
        </div>
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [(ngModel)]="newOccurrence.motiveOccurrence"
              [filter]="true"
              [showClear]="true"
              [class]="!newOccurrence.motiveOccurrence ? 'ng-invalid ng-dirty' : ''"
              [options]="motives"
              optionLabel="description"
              optionValue="id"
              [style]="stylePattern"
              inputId="filterMotivo"
              placeholder="Selecionar"
              [disabled]="!newOccurrence.contractId"
            ></p-dropdown>
            <label htmlFor="filterMotivo">Motivo</label>
          </span>
        </div>
      </div>
      <!-- <div class="grid mt-3">
        <div class="col-12">
          <span class="p-float-label">
            <p-dropdown
            [(ngModel)]="newOccurrence.operation"
            [filter]="true"
            [showClear]="true"
            [class]="!newOccurrence.operation ? 'ng-invalid ng-dirty' : ''"
            [options]="operations"
            optionLabel="operation"
            optionValue="id"
            [style]="stylePattern"
            inputId="filterOperacao"
            placeholder="Selecionar"
            [disabled]="!newOccurrence.contractId"
            ></p-dropdown>
            <label htmlFor="filterOperacao">Operação</label>
          </span>
        </div>
      </div> -->
      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <input
            [class]="!newOccurrence.description ? 'min-w-full ng-invalid ng-dirty' : 'min-w-full'"
            [style]="stylePattern"
            type="text"
            pInputText
            htmlFor="filterDescricao"
            [(ngModel)]="newOccurrence.description"
            [required]="true"
            />
            <label htmlFor="filterDescricao">Descrição</label>
          </span>
        </div>
        <div class="col-3">
          <span class="p-float-label">
<p-dropdown
  [(ngModel)]="newOccurrence.originId"
  [filter]="true"
  [showClear]="true"
  [class]="!newOccurrence.originId ? 'ng-invalid ng-dirty' : ''"
  [options]="devices"
  optionLabel="deviceName"
  optionValue="deviceId"
  [style]="stylePattern"
  inputId="filterDevice"
  placeholder="Selecionar"
  [disabled]="!newOccurrence.contractId"
>
  <ng-template pTemplate="empty">
    <div *ngIf="devicesLoading; else semResposta">
      <p-progressSpinner
        [style]="{width: '20px', height: '20px'}"
        styleClass="spinner-azul">
      </p-progressSpinner>
    </div>
    <ng-template #semResposta>
      Sem Resposta
    </ng-template>
  </ng-template>
</p-dropdown>
<label htmlFor="filterDevice">Equipamento</label>
          </span>
        </div>
        <div class="col-3">
          <span class="p-float-label">
          <p-dropdown
            [(ngModel)]="newOccurrence.lane"
            [filter]="true"
            [showClear]="true"
            [style]="stylePattern"
            [options]="lanes"
            inputId="filterLane"
            placeholder="Selecionar"
            >
          </p-dropdown>
          <label htmlFor="filterLane">Pista</label>
          </span>
        </div>
      </div>

      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <p-calendar
              [style]="stylePattern"
              selectionMode="range"
              [readonlyInput]="true"
              inputId="filterRange"
              [class]="!verifyVariables() ? 'ng-invalid ng-dirty' : ''"
              [(ngModel)]="rangeDates"
              [maxDate]="maxDate"
              (onSelect)="onRangeSelect($event)"
            ></p-calendar>
            <label htmlFor="filterRange">Intervalo</label>
          </span>
        </div>
        <div class="col-3">
          <span class="p-float-label">
            <p-calendar
              timeMask
              [style]="stylePattern"
              [readonlyInput]="false"
              [timeOnly]="true"
              [showTime]="true"
              hourFormat="24"
              inputId="filterHoraInit"
              placeholder="hh:mm"
              [(ngModel)]="newOccurrence.startHour"
              [ngClass]="{'limit-hour-start': isHourAtStartLimit(), 'limit-minute-start': isMinuteAtStartLimit()}"
              (ngModelChange)="onStartHourChange($event)"
            ></p-calendar>

            <label htmlFor="filterHoraInit">Hora Início</label>
          </span>
        </div>
        <div class="col-3">
          <span class="p-float-label">
            <p-calendar
                timeMask
                [style]="stylePattern"
                [readonlyInput]="false"
                inputId="filterHoraFim"
                [timeOnly]="true"
                [showTime]="true"
                hourFormat="24"
                placeholder="hh:mm"
                [(ngModel)]="newOccurrence.endHour"
                [ngClass]="{'limit-hour-end': isHourAtEndLimit(), 'limit-minute-end': isMinuteAtEndLimit()}"
                (ngModelChange)="onEndHourChange($event)"
              ></p-calendar>

            <label htmlFor="filterHoraFim">Hora Fim</label>
          </span>
        </div>
      </div>
      <!-- <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <input
            [class]="!newOccurrence.deliveryProtocol ? 'min-w-full ng-invalid ng-dirty' : 'min-w-full'"
            [style]="stylePattern"
            type="text"
            pInputText
            inputId="filterDeliveryProtocol"
            [(ngModel)]="newOccurrence.deliveryProtocol"
            [required]="true"
            />
            <label htmlFor="filterDeliveryProtocol">Protocolo de entrega</label>
          </span>
        </div>
        <div class="col-3">
          <span class="p-float-label">
            <p-calendar
              [class]="!newOccurrence.protocolDate ? 'ng-invalid ng-dirty' : ''"
              [style]="stylePattern"
              [(ngModel)]="newOccurrence.protocolDate"
              [readonlyInput]="true"
              [showClear]="true"
              inputId="protocolDate"
            ></p-calendar>
            <label htmlFor="protocolDate">Data Protocolo</label>
          </span>
        </div>
        <div class="col-3">
          <span class="p-float-label">
            <p-calendar
              [style]="stylePattern"
              [readonlyInput]="true"
              inputId="protocolHour"
              [timeOnly]="true"
              [showTime]="true"
              hourFormat="24"
              placeholder="hh:mm"
              [(ngModel)]="newOccurrence.protocolHour"
            ></p-calendar>
            <label htmlFor="protocolHour">Hora Protocolo</label>
          </span>
        </div>
      </div> -->
      <div class="grid mt-3">
        <div class="col-12">
          <span class="p-float-label">
            <textarea
              pInputTextarea
              id="filterAnotacoes"
              class="min-w-full"
              [(ngModel)]="newOccurrence.notes"
              [rows]="4"
              [autoResize]="true"
            ></textarea>
            <label htmlFor="filterAnotacoes">Anotações</label>
          </span>
        </div>
      </div>
      <div class="grid mt-3">
        <div class="col-2">
          <p-button
            [style]="{height: '40px', width: '100%'}"
            label="Anexar arquivo"
            size="small"
            icon="pi pi-paperclip"
            (click)="showDialog()"
          ></p-button>
        </div>
        <!-- <div class="col-3">
          <p-checkbox label="Rejeitado Pelo Orgão" [(ngModel)]="newOccurrence.rejected" [binary]="true"></p-checkbox>
        </div> -->
        <div class="col-2 text-align: right;">
          <!-- <p-button
            class="block relative top-100 -translate-y-100"
            [style]="{ height: '40px' }"
            (onClick)="createOccurrence()"
            [loading]="buttonLoading"
            label="Salvar"
            size="small"
            [disabled]="!verifyVariables() || !this.newOccurrence.description || !this.newOccurrence.contractId || !this.newOccurrence.motiveOccurrence
            || !this.newOccurrence.operation || !this.newOccurrence.protocolDate || !this.newOccurrence.deliveryProtocol || buttonLoading"
            icon="pi pi-save"
          ></p-button> -->

            <p-button
              label="Salvar"
              [style]="{ height: '40px', width: '100%' }"
              (onClick)="createOccurrence()"
              [loading]="buttonLoading"
              everity="primary"
              size="small"
              icon="pi pi-save"
              [disabled]="!verifyVariables() || !this.newOccurrence.description || !this.newOccurrence.contractId || !this.newOccurrence.originId || !this.newOccurrence.motiveOccurrence || buttonLoading"
            ></p-button>

        </div>

          <div class="col-2 text-align: right;">
            <p-button label="Primary" [outlined]="true"
              label="Limpar"
              icon="pi pi-times"
              severity="primary"
              size="small"
              [style]="{ height: '40px', width: '100%' }"
              (click)="clearOccurrenceForm()">
            </p-button>
        </div>
      </div>

      <div class="mt-5 pt-4 border-top-1 surface-border">
        <div class="flex align-items-center justify-content-between mb-3">
          <h5 class="m-0">
            <i class="pi pi-paperclip mr-2"></i>
            Anexos ({{ getActiveAttachmentsCount() }} / {{ MAX_ATTACHMENTS }})
          </h5>
        </div>

        <div *ngIf="attachments.length === 0 && uploadedFiles.length === 0" class="text-center py-4">
          <i class="pi pi-inbox text-4xl text-400 mb-3"></i>
          <p class="text-500 m-0">Nenhum anexo adicionado</p>
        </div>

        <div *ngIf="attachments.length > 0">
          <h6 class="mb-3">
            <i class="pi pi-cloud mr-2"></i>
            Arquivos Salvos ({{ attachments.length - attachmentsToDelete.length }})
          </h6>
          <div class="border-round border-1 surface-border p-3 mb-3">
            <ul class="list-none p-0 m-0">
              <li
                *ngFor="let attachment of attachments"
                [class.opacity-50]="isMarkedForDeletion(attachment.id)"
                class="flex align-items-center justify-content-between py-2 px-3 mb-2 border-round surface-hover">
                <div class="flex align-items-center">
                  <i class="pi pi-file text-primary mr-3 text-xl"></i>
                  <div>
                    <div class="font-semibold" [class.line-through]="isMarkedForDeletion(attachment.id)">
                      {{ attachment.name }}
                    </div>
                    <div class="text-sm text-500">
                      {{ attachment.size | fileSize }}
                    </div>
                    <div class="text-sm text-500">{{attachment.userName}} - {{ attachment.uploadDate | date:'dd/MM/yyyy' }}</div>
                  </div>
                </div>
                <div class="flex gap-2">
                  <button
                    *ngIf="!isMarkedForDeletion(attachment.id)"
                    pButton
                    pRipple
                    icon="pi pi-download"
                    class="p-button-rounded p-button-text p-button-info"
                    pTooltip="Baixar arquivo"
                    tooltipPosition="top"
                    (click)="onDownloadAttachment(attachment)">
                  </button>
                  <button
                    *ngIf="!isMarkedForDeletion(attachment.id) && canPreview(attachment.name)"
                    pButton
                    pRipple
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-text p-button-info"
                    pTooltip="Visualizar arquivo"
                    tooltipPosition="top"
                    (click)="onPreviewAttachment(attachment)">
                  </button>
                  <button
                    *ngIf="!isMarkedForDeletion(attachment.id)"
                    pButton
                    pRipple
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    pTooltip="Remover arquivo"
                    tooltipPosition="top"
                    (click)="markAttachmentForDeletion(attachment.id)">
                  </button>
                  <button
                    *ngIf="isMarkedForDeletion(attachment.id)"
                    pButton
                    pRipple
                    icon="pi pi-undo"
                    class="p-button-rounded p-button-text p-button-warning"
                    pTooltip="Desfazer remoção"
                    tooltipPosition="top"
                    (click)="unmarkAttachmentForDeletion(attachment.id)">
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="uploadedFiles.length > 0" [class.mt-3]="attachments.length > 0">
          <h6 class="mb-3">
            <i class="pi pi-upload mr-2"></i>
            Novos Arquivos ({{ uploadedFiles.length }})
          </h6>
          <div class="border-round border-1 surface-border p-3">
            <ul class="list-none p-0 m-0">
              <li
                *ngFor="let file of uploadedFiles; let i = index"
                class="flex align-items-center justify-content-between py-2 px-3 mb-2 border-round surface-hover">
                <div class="flex align-items-center">
                  <i class="pi pi-file text-blue-500 mr-3 text-xl"></i>
                  <div>
                    <div class="font-semibold">{{ file.name }}</div>
                    <div class="text-sm text-500">
                      {{ file.size | fileSize }}
                    </div>
                  </div>
                </div>
                <div class="flex gap-2">
                  <button
                    *ngIf="canPreview(file.name)"
                    pButton
                    pRipple
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-text p-button-info"
                    pTooltip="Visualizar arquivo"
                    tooltipPosition="top"
                    (click)="onPreviewFile(file)">
                  </button>
                  <button
                    pButton
                    pRipple
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    pTooltip="Remover"
                    tooltipPosition="top"
                    (click)="removeNewFile(i)">
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </p-fieldset>

    <p-dialog
      header="Adicionar Anexos"
      [(visible)]="isVisible"
      [modal]="true"
      [style]="{width: '50vw'}"
      [dismissableMask]="false"
      [closable]="false">

      <div>
        <h5 class="mb-3">
          <i class="pi pi-upload mr-2"></i>
          Selecionar Arquivos
        </h5>

        <div *ngIf="getActiveAttachmentsCount() >= MAX_ATTACHMENTS" class="mb-3 p-3 border-round bg-yellow-50 text-yellow-900">
          <i class="pi pi-exclamation-triangle mr-2"></i>
          Limite de {{MAX_ATTACHMENTS}} anexos atingido
        </div>

        <p-fileUpload
          #fileUpload
          name="files[]"
          chooseLabel="Escolher"
          [multiple]="true"
          accept=".pdf,.jpg,.jpeg,.png,.webp,.mp4,.mov,.csv,.xlsx,.docx,.txt,.json,.log,.zip"
          [maxFileSize]="MAX_FILE_SIZE"
          invalidFileSizeMessageSummary="Arquivo muito grande"
          [invalidFileSizeMessageDetail]="'O tamanho máximo permitido é de ' + (MAX_FILE_SIZE / (1024 * 1024)) + ' MB'"
          (onSelect)="onFileSelect($event)"
          [showUploadButton]="false"
          [showCancelButton]="false"
          [auto]="false"
          [customUpload]="true"
          [disabled]="getActiveAttachmentsCount() >= MAX_ATTACHMENTS"
          [files]="uploadedFiles"
          invalidFileTypeMessageSummary="{0}: Tipo de arquivo inválido,"
          invalidFileTypeMessageDetail="Tipos de arquivos permitidos: pdf, jpg, jpeg, png, webp, mp4, mov, csv, xlsx, docx, txt, json, log, zip.">
          <ng-template pTemplate="content">
            <div *ngIf="uploadedFiles.length === 0" class="text-center p-4">
              <i class="pi pi-cloud-upload text-4xl text-400"></i>
              <p class="mt-3 text-500">
                {{ getActiveAttachmentsCount() >= MAX_ATTACHMENTS ?
                   'Limite de anexos atingido' :
                   'Arraste arquivos aqui ou clique para selecionar' }}
              </p>
            </div>

            <ul *ngIf="uploadedFiles.length > 0" class="list-none p-0 m-0">
              <li
                *ngFor="let file of uploadedFiles; let i = index"
                class="flex align-items-center justify-content-between py-2 px-3 mb-2 border-round surface-hover">
                <div class="flex align-items-center">
                  <i class="pi pi-file text-blue-500 mr-3 text-xl"></i>
                  <div>
                    <div class="font-semibold">{{ file.name }}</div>
                    <div class="text-sm text-500">
                      {{ file.size | fileSize }}
                    </div>
                  </div>
                </div>
                <div class="flex gap-2">
                  <button
                    *ngIf="canPreview(file.name)"
                    pButton
                    pRipple
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-text p-button-info"
                    pTooltip="Visualizar arquivo"
                    tooltipPosition="top"
                    (click)="onPreviewFile(file)">
                  </button>
                  <button
                    pButton
                    pRipple
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    pTooltip="Remover"
                    tooltipPosition="top"
                    (click)="removeNewFile(i)">
                  </button>
                </div>
              </li>
            </ul>
          </ng-template>
        </p-fileUpload>
      </div>

      <ng-template pTemplate="footer">
        <div class="flex justify-content-between align-items-center w-full">
          <div class="text-sm text-500">
            Total: {{ getActiveAttachmentsCount() }} / {{ MAX_ATTACHMENTS }} arquivo(s)
          </div>
          <div class="flex gap-2">
            <button
              pButton
              label="Ok"
              icon="pi pi-check"
              (click)="closeDialog()">
            </button>
          </div>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      *ngIf="preview"
      [header]="preview.fileName"
      [(visible)]="preview.visible"
      [modal]="true"
      [closable]="true"
      [style]="{width: '80vw'}"
      [contentStyle]="{'height': '70vh'}"
      (onHide)="closePreview()">
      <p-skeleton *ngIf="preview.loading" width="100%" height="100%"></p-skeleton>

      <ng-container *ngIf="!preview.loading" [ngSwitch]="preview.kind">
        <img
          *ngSwitchCase="'image'"
          style="width: 100%; height: 100%; object-fit: contain; display: block"
          [src]="preview.objectUrl"
          [alt]="preview.fileName">

        <iframe
          *ngSwitchCase="'pdf'"
          style="width: 100%; height: 100%; border: 0"
          [src]="preview.safeResourceUrl"
          [title]="preview.fileName">
        </iframe>

        <pre
          *ngSwitchCase="'json'"
          style="height: 100%; margin: 0; padding: 1rem; overflow: auto; white-space: pre-wrap; word-break: break-word">{{ preview.text }}</pre>

        <div *ngSwitchCase="'xlsx'" style="height: 100%; overflow: auto">
          <table style="width: 100%; border-collapse: collapse; font-size: 0.875rem">
            <tbody>
              <tr *ngFor="let row of preview.rows">
                <td
                  *ngFor="let cell of row"
                  style="min-width: 120px; max-width: 320px; padding: 0.5rem; border: 1px solid #e5e7eb; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </p-dialog>
  </p-card>
</div>
